import Global from '../../js/constant.js'
import axios from 'axios'

const favorite = {
  state: {
    favorCircles: [],
  },
  getters: {
    favorCircles(state) { return state.favorCircles },

  },
  mutations: {
    setFavorCircles (state, value) {
      state.favorCircles = value
    },
  },
  actions: {
    getFavorCircles ({commit}, account) {
      if (!account) return 
      axios.post(Global.url.api_refer_circles_search, {account_id: account.id})
      .then (res => {
        if (res.data.status == Global.api_status.success) {
          commit('setFavorCircles', res.data.refer_circles)
        }
      })
      .catch (error => { console.log(error) })
    },
  },
  modules: {}
}
export default favorite